import { ChangeDetectionStrategy, Component } from "@angular/core";
import { PageComponent } from "@components/page/page.component";
import { ExternArbetsorderSearchPanelComponent } from "./extern-arbetsorder-search-panel/extern-arbetsorder-search-panel.component";
import { ExternArbetsorderSearchResultComponent } from "./extern-arbetsorder-search-result/extern-arbetsorder-search-result.component";

@Component({
    selector: "rask-extern-arbetsorder-search",
    templateUrl: "./extern-arbetsorder-search.component.html",
    styleUrls: ["./extern-arbetsorder-search.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        PageComponent,
        ExternArbetsorderSearchPanelComponent,
        ExternArbetsorderSearchResultComponent
    ]
})
export class ExternArbetsorderSearchComponent {
}
